import React from 'react';
import steps from './siteSteps/index.js';
import siteUtils from '../../utils/site';
import Asset from './siteSteps/asset';
import SiteAssets from './siteSteps/siteAssets';

const { Settings, Solutions, Locations } = steps;

const siteSteps = (site, setSite, projectId, createMode) => {
  const siteSteps = [
    {
      title: 'Settings',
      required: true,
      content: <Settings site={site} updateSite={setSite} />,
      validation: () => {
        return site ? !siteUtils.hasErrorsCheck(site, 'settings') : false;
      }
    },
    {
      title: 'Solution',
      required: true,
      content: <Solutions site={site} updateSite={setSite} />,
      validation: () => {
        return site ? !siteUtils.hasErrorsCheck(site, 'solution') : false;
      }
    },
    {
      title: 'Location',
      required: true,
      content: <Locations site={site} updateSite={setSite} createMode={createMode} />,
      validation: () => {
        return site ? !siteUtils.hasErrorsCheck(site, 'location') : false;
      }
    },
    {
      title: 'Assets',
      modified: () => createMode && Boolean(site.assets?.length),
      submitButtonTitle: createMode && !site.assets?.length ? 'Skip & Submit' : 'Submit',
      contentClasses: createMode ? 'site-asset-step' : 'site-assets-management-step',
      content: createMode ? (
        <Asset projectId={projectId} site={site} updateSite={setSite} />
      ) : (
        <SiteAssets projectId={projectId} site={site} updateSite={setSite} />
      )
    }
  ];
  // if (site.cmsVendors && site.cmsVendors.length > 0) {
  //   siteSteps.push({
  //     title: `Integration: ${site.cmsVendors[0].charAt(0).toUpperCase() + site.cmsVendors[0].slice(1).toLowerCase()}`,
  //     content: <Integrations site={site} updateSite={setSite} />
  //   });
  // }
  return siteSteps;
};

export default siteSteps;
